var $ = jQuery = require('jquery');

var app = {
  init: function(){
    $('body').on('click', '#search-icon, #search-close', app.toggleMenu);
  },

  toggleMenu: function(){
    $('#search-overlay').toggle();
  },
};

$(app.init);
